import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["content", "title"]

  connect() {
    this.currentFilter = this.element.querySelector(".active")
  }

  toggle(event) {
    const self = this
    this._setFilter(event.target)
    this.contentTargets.forEach((content) => {
      const tagsAttribute = content.getAttribute("data-filter-tags-value")
      const tags = tagsAttribute?.split(",").filter(n => n).map(n => n.trim()) || []
      const currentFilterText  = self.currentFilter.innerText
      if (tags.includes(currentFilterText) || currentFilterText === "All") {
        // Clear the inline override: the stylesheet decides how a
        // visible card lays out (flex in legacy, grid in portal_next —
        // a hardcoded "block" flattened both)
        content.style.removeProperty("display")
      } else {
        content.style.display = "none"
      }
    })
  }

  _setFilter(button) {
    if (!button.classList.contains("active")) {
      this.currentFilter?.classList.remove("active")
      button.classList.add("active")
      this.currentFilter = this.element.querySelector(".active")
      this.titleTarget.innerText = button.innerText
    }}
}
